import trans_bg from 'assets/trans_bg.png'

export const isTtdEnabled = stg => parseInt(stg?.stgttddokter) !== 0

export const isStempelEnabled = stg => parseInt(stg?.stgstempeldokter) !== 0

export const areCetakImagesReady = (stg, imageLoad) =>
  (!isTtdEnabled(stg) || imageLoad.ttd) &&
  (!isStempelEnabled(stg) || imageLoad.stempel)

export const markCetakImageReady = (setimageLoad, type) => {
  setimageLoad(prev => (prev[type] ? prev : {...prev, [type]: true}))
}

export const preloadCetakImage = (url, type, setimageLoad) => {
  const markReady = () => markCetakImageReady(setimageLoad, type)
  const src = url || trans_bg

  const img = new Image()
  img.onload = markReady
  img.onerror = markReady
  img.src = src

  if (img.complete) markReady()
}

export const bindCetakImageRef = (type, setimageLoad) => node => {
  if (node?.complete) markCetakImageReady(setimageLoad, type)
}

export const waitForPrintPaint = () =>
  new Promise(resolve => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setTimeout(resolve, 350)
      })
    })
  })
